import { useMemo } from 'react'
import { LidoSDK } from '@lidofinance/lido-ethereum-sdk'
import { getChainById } from '~/utils/chain'
import { useWalletClient } from 'wagmi'
import { mainnet } from 'viem/chains'
import { WalletClient } from 'viem'

let cachedLidoSDK: LidoSDK | null = null
let cachedRpcUrl: string | undefined
let cachedWalletClient: WalletClient | undefined

const getOrCreateLidoSDK = (rpcUrl: string, walletClient?: WalletClient) => {
  if (
    !cachedLidoSDK ||
    cachedRpcUrl !== rpcUrl ||
    cachedWalletClient !== walletClient
  ) {
    cachedLidoSDK = new LidoSDK({
      chainId: 1,
      rpcUrls: [rpcUrl],
      web3Provider: walletClient,
    })
    cachedRpcUrl = rpcUrl
    cachedWalletClient = walletClient
  }

  return cachedLidoSDK
}

export const useLidoSDK = () => {
  const chainId = mainnet.id
  const rpcUrl = getChainById(chainId).rpcUrl
  const { data: walletClient } = useWalletClient()

  const lidoSDK = useMemo(() => {
    return getOrCreateLidoSDK(rpcUrl, walletClient)
  }, [walletClient, rpcUrl])

  return lidoSDK
}
